import { getFeatureFlagsUrl } from "../config/Config";
import { getRequest } from "./ServiceHelper";

export class FeatureFlagService {
  static getFeatureFlags = (tenant) => {
    return getRequest(getFeatureFlagsUrl(), tenant);
  };
}
